<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import ContentCourseSection from "@/components/Dashboard/Users/Course/ContentCourseSection.vue";
</script>

<template>
  <ContentHeader :name="'Course Users'" />
  <ContentCourseSection />
</template>
